<template>
    <section class="container">
      <div class="route"><br>
      </div>
      <div class="wide-window">
        <h1>{{categoria}}</h1>
          <div class="form-group">
                    <label class="labelClaveFirma">Introduzca las posiciones solicitadas de su clave de firma</label>
                    <div class="claveFirma">
                      <div class="providerReference"> <!--En un futuro este div se generara de manera dinamica, como el teclado virtual-->
                        <input class="inputLoginComponent primeraPosicion" disabled type="text" name="firstGroup" maxlength="1" value="*">
                        <input class="inputLoginComponent" disabled type="text" name="firstGroup" maxlength="1" v-model="providerReference.firstGroup" required>
                        <input class="inputLoginComponent" disabled type="text" name="secondGroup" maxlength="1" v-model="providerReference.secondGroup" required>
                        <input class="inputLoginComponent" disabled type="text" name="firstGroup" maxlength="1" value="*">
                        <input class="inputLoginComponent" disabled type="text" name="firstGroup" maxlength="1" value="*">
                        <input class="inputLoginComponent" disabled type="text" name="thirdGroup" maxlength="1" v-model="providerReference.thirdGroup" required>
                        <input class="inputLoginComponent" disabled type="text" name="fourthGroup" maxlength="1" v-model="providerReference.fourthGroup" required>
                        <input class="inputLoginComponent" disabled type="text" name="firstGroup" maxlength="1" value="*">
                      </div>
                      <div class="botonera">
                        <div class="botones">
                          <button v-for="num in numeros" v-bind:key="num" class="botonPantalla" @click="tecladoVirtual($event)">{{num}}</button>
                        </div>
                        <button class="botonBorrar" @click="borrar()">
                          Borrar
                        </button>
                      </div>
                    </div>
                    <div>
                    <!-- Boton aceptar -->
                    <input type="submit" class="btnPrimary separacion" @click="aceptarClave()" value="Aceptar" :disabled="isDisabled">
                    <!-- Boton cancelar -->
                    <input type="button" class="btnSecondary" @click="cancelar()" value="Cancelar">
                    </div>
          </div>
      </div>
    </section>
</template>

<script>
import ProviderReference from '../models/ProviderReference';
export default {
    name : 'SignTransferComponent',
    data(){
      return{
        numeros:null,
        datosSalida:null,
        mensajeError:'Algo ha ido mal, asegúrate que has introducido correctamente tus datos', //mensaje de error por defecto
        confirmacion:null,
        categoria:'Firma de la operaci\u00F3n',
        providerReference : new ProviderReference()
      }
    },
    props: {
      datosFirma: []
    },
    watch: {
      'datosFirma': function() {
        this.callMe();
      }
    },
    computed : {
      isDisabled: function() { //aqui pondremos los campos obligatorios de nuestro form
        return  !this.providerReference.firstGroup || !this.providerReference.secondGroup || !this.providerReference.thirdGroup || !this.providerReference.fourthGroup;
      }
    },
    mounted: function(){
      var arrayTeclado=new Array();
      var numActual;
      var i;
      for(i=0;i<10;i){
        numActual=Math.floor(Math.random() * 10);
        if(!arrayTeclado.includes(numActual)){
          arrayTeclado.push(numActual);
          i++;
        }
      }
      this.numeros=arrayTeclado;
    },
    methods: {
      callMe() {
        alert('Call this function from parent');
      },
      tecladoVirtual(elemento){
        if(!this.providerReference.firstGroup){
            this.providerReference.firstGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.secondGroup){
            this.providerReference.secondGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.thirdGroup){
            this.providerReference.thirdGroup=elemento.target.innerHTML;
          }else if(!this.providerReference.fourthGroup){
            this.providerReference.fourthGroup=elemento.target.innerHTML;
          }
      },
      borrar(){
        if(this.providerReference.fourthGroup){
          this.providerReference.fourthGroup=null;
        }else if(this.providerReference.thirdGroup){
          this.providerReference.thirdGroup=null;
        }else if(this.providerReference.secondGroup){
          this.providerReference.secondGroup=null;
        }else{
          this.providerReference.firstGroup=null;
        }
      },
      aceptarClave(){ //llamada al web service
          const ventana=this;
          let datos;
          const baseURI = this.$route.params.urlEndpoint;
          let loader = this.$loading.show();
          if(this.$route.params.entrada!=null){
            datos=this.$route.params.entrada;
          }
          if(this.$route.params.metodo=='POST'){
            this.$http.post(baseURI,datos)
            .then((result) => {
              this.datosSalida=result;
              //operacion realizada correctamente
            })
            .catch(function (error) {
              if(error.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                ventana.mensajeError=error.result.errors[0].errorDescription;
              }else{ //si no, por defecto
                ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
              }
              ventana.confirmacion='KO';
            })
            .then(function () {
              loader.hide();
            });
          }else if(this.$route.params.metodo=='PUT'){
            this.$http.put(baseURI,datos)
            .then((result) => {
              this.datosSalida=result;
              //operacion realizada correctamente
            })
            .catch(function (error) {
              if(error.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                ventana.mensajeError=error.result.errors[0].errorDescription;
              }else{ //si no, por defecto
                ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
              }
              ventana.confirmacion='KO';
            })
            .then(function () {
              loader.hide();
            });
          }
          if(this.$route.params.volver){
            this.$router.push(this.$route.params.urlComponente);
          }else{
            this.$router.push('/onesaitConfirmingProviders/home');
          }
      },
      cancelar(){
        this.$router.push('/onesaitConfirmingProviders/gestion-anticipos/anticipo-ordenes-marcadas');
      }
    }
}
</script>